export const ActionTypes = {
  FETCH_S3_SETTINGS: 'services/dashboards/prismatic/fetch_s3_settings',
  SET_S3_SETTINGS: 'services/dashboards/prismatic/set_s3_settings',
};

const fetchS3Settings = () => ({
  type: ActionTypes.FETCH_S3_SETTINGS,
});

const setS3Settings = ({ s3Settings }) => ({
  s3Settings,
  type: ActionTypes.SET_S3_SETTINGS,
});

export default {
  fetchS3Settings,
  setS3Settings,
};
